import { render, staticRenderFns } from "./ExerciseInfoModal.vue?vue&type=template&id=b60b0310&"
import script from "./ExerciseInfoModal.vue?vue&type=script&lang=js&"
export * from "./ExerciseInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseInfoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports